import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from "react";
import { FlattenedBoardSearchToken } from "~/components/Search/SearchTokens/FlattenedBoardSearchToken";
import { useSearchTokenLogic } from "~/components/Search/SearchTokens/useSearchTokenLogic";
import { SearchToken } from "~/components/SearchBar/SearchToken";
import { SEARCH_BOARD_TOKEN } from "~/constants/testIDs";
import { useIsFlattenedView } from "~/hooks/search/useIsFlattenedView";
export const useBoardSearchToken = (param)=>{
    let { hasValue, isFocused, boardName, onSearchTokenToggle, searchBarRef } = param;
    const { isFlattenedView, setIsFlattenedView } = useIsFlattenedView();
    const { showToken, isTokenVisible, wasTokenRemoved, hideToken } = useSearchTokenLogic({
        hasValue,
        isFocused
    });
    useEffect(()=>{
        onSearchTokenToggle === null || onSearchTokenToggle === void 0 ? void 0 : onSearchTokenToggle(!wasTokenRemoved);
    }, [
        wasTokenRemoved,
        onSearchTokenToggle
    ]);
    const onBackspacePress = useCallback(()=>{
        if (!wasTokenRemoved) {
            isFlattenedView ? setIsFlattenedView(false) : hideToken();
        }
    }, [
        hideToken,
        isFlattenedView,
        setIsFlattenedView,
        wasTokenRemoved
    ]);
    const BoardToken = useMemo(()=>{
        if (isFlattenedView) {
            return /*#__PURE__*/ _jsx(FlattenedBoardSearchToken, {
                boardName: boardName
            });
        } else if (isTokenVisible && !!boardName) {
            return /*#__PURE__*/ _jsx(SearchToken, {
                testId: SEARCH_BOARD_TOKEN,
                tokenName: boardName,
                color: "grey",
                onCloseClick: ()=>{
                    if (!isFocused) {
                        var _searchBarRef_current;
                        searchBarRef === null || searchBarRef === void 0 ? void 0 : (_searchBarRef_current = searchBarRef.current) === null || _searchBarRef_current === void 0 ? void 0 : _searchBarRef_current.focus();
                    }
                    hideToken();
                }
            });
        } else {
            return null;
        }
    }, [
        boardName,
        hideToken,
        isFlattenedView,
        isFocused,
        isTokenVisible,
        searchBarRef
    ]);
    return {
        BoardToken,
        onBackspacePress,
        wasTokenRemoved,
        showToken
    };
};
